import PropTypes from "prop-types";
import React from "react";
import useLeadSources from "~/hooks/useLeadSources";
import Select from "./SelectWrapper/Select";

const SourceSelect = ({
  id = "",
  name = "",
  value = "",
  placeholder = "Select Source",
  onChange = () => undefined,
  isMulti = false,
  isClearable = false,
  addBlank = false,
  ...restProps
}) => {
  const { options, loading } = useLeadSources();

  return (
    <Select
      validateValue
      id={id}
      name={name}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      isMulti={isMulti}
      isClearable={isClearable}
      isSearchable
      isLoading={loading}
      options={options}
      addBlank={addBlank}
      {...restProps}
    />
  );
};

SourceSelect.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
  ]),
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  isMulti: PropTypes.bool,
  isClearable: PropTypes.bool,
  addBlank: PropTypes.bool,
};

export default SourceSelect;
